export enum ContentTypes {
  BLOG_POSTS = "blog-posts",
  CODE_EXERCISES = "code-exercises",
  COURSES = "courses",
  MARKETING_PAGE = "marketing-page",
  EXERCISE_SOLUTION = "exercise-solutions",
}
